// Generator-discovered file route for the verticals (niches) registry.
// Component lives in `src/ad/routes/verticals.tsx` (Module P / P7 — the create/
// list surface that bootstraps AI Studio, since every brief needs a verticalId).
import { createFileRoute } from '@tanstack/react-router';
import { VerticalsRouteComponent } from '@/ad/routes/verticals';

export const Route = createFileRoute('/_authenticated/ad/verticals')({
  component: VerticalsRouteComponent,
});
